import axios from 'axios';
import {API_BASE, VERAPP} from 'components/constants';

/*
const clienteAxios = axios.create({
    baseURL : process.env.REACT_APP_BACKEND_URL
});
*/

const clienteAxios = axios.create({
        baseURL: API_BASE,
});

clienteAxios.interceptors.request.use(
        function (config) {
                
                config.data.VERAPP = VERAPP;

                return config;
        },
        function (error) {
                return Promise.reject(error);
        }
);
/*
clienteAxios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    return Promise.reject(error);
});
*/
export default clienteAxios;
